'use client';

import { AnchorHTMLAttributes, ReactNode } from 'react';

import styled from 'styled-components';

import { ButtonContainer, IconContainer } from './styles';

const PrimaryButtonAnchor = styled(ButtonContainer).attrs({ as: 'a' })`
  text-decoration: none;
  color: inherit;
`;

export interface PrimaryButtonLinkProps
  extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'children'> {
  icon: ReactNode;
  label: ReactNode;
  isActive?: boolean;
}

export const PrimaryButtonLink = ({
  icon,
  label,
  isActive = false,
  ...anchorProps
}: PrimaryButtonLinkProps) => {
  return (
    <PrimaryButtonAnchor $isActive={isActive} {...anchorProps}>
      <IconContainer $isActive={isActive}>{icon}</IconContainer>
      {label}
    </PrimaryButtonAnchor>
  );
};
